import chevronDownUrl from '@/assets/icons/chevron-down.svg'
import type { Dong } from '@/types/serviceArea'

import {
  Body,
  Card,
  ChevronIcon,
  DongChip,
  DongCount,
  FullCoverageChip,
  GroupName,
  Header,
  HeaderRight,
} from './styles'

interface DongAccordionProps {
  /**
   * 카드 라벨.
   *  - 일반구 보유 시군구: 일반구 이름 ("덕양구")
   *  - 일반구 없는 시군구: "전체" 또는 시군구 이름 — 호출자 판단
   */
  groupName: string
  dongList: Dong[]
  isOpen: boolean
  onToggle: () => void
  /**
   * 시군구/일반구 isFullCoverage=true일 때 노출하는 "전 지역 가능" 칩.
   * 카운트 좌측에 강조용으로 표시 (피그마 16359:25379).
   */
  showFullCoverageChip?: boolean
}

/**
 * 펼치면 dongList chips가 나오는 카드.
 * 한 시군구 안에 여러 개 등장 가능 (일반구별 1개씩).
 *
 * isFullCoverage 시군구도 펼침 가능 — `showFullCoverageChip`으로 강조만 추가.
 * 별도 정적 카드 없음 (디자이너 의도, 피그마 17740:44478).
 *
 * 스크롤 타겟 id 는 부모 SiGunGuGroup wrapper 에 부착 — 본 카드 자체는 id 없음.
 */
export default function DongAccordion({
  groupName,
  dongList,
  isOpen,
  onToggle,
  showFullCoverageChip,
}: DongAccordionProps) {
  return (
    <Card>
      <Header
        type='button'
        onClick={onToggle}
        aria-expanded={isOpen}>
        <GroupName>{groupName}</GroupName>
        <HeaderRight>
          {showFullCoverageChip && <FullCoverageChip>전 지역 가능</FullCoverageChip>}
          <DongCount>{dongList.length}개 동</DongCount>
          <ChevronIcon
            src={chevronDownUrl}
            alt=''
            data-open={isOpen ? '' : undefined}
          />
        </HeaderRight>
      </Header>
      {isOpen && (
        <Body>
          {dongList.map((dong) => (
            <DongChip key={dong.id}>{dong.name}</DongChip>
          ))}
        </Body>
      )}
    </Card>
  )
}
